module.exports = __webpack_public_path__ + "img/browser.e56f0753.svg";